import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "label", "checked", "defaultChecked", "disabled", "onChange", "inputRef", "tabIndex", "name", "id", "autoFocus", "children", "invalid", "value", "role"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { HiddenInput } from '../HiddenInput';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ControlInputContainer = /*#__PURE__*/React.forwardRef(function ControlInputContainer(props, ref) {
  var type = props.type,
    label = props.label,
    checked = props.checked,
    defaultChecked = props.defaultChecked,
    disabled = props.disabled,
    onChange = props.onChange,
    inputRef = props.inputRef,
    tabIndex = props.tabIndex,
    name = props.name,
    id = props.id,
    autoFocus = props.autoFocus,
    children = props.children,
    invalid = props.invalid,
    value = props.value,
    role = props.role,
    rest = _objectWithoutProperties(props, _excluded);
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e, e.currentTarget.checked);
    }
  };
  return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread({}, rest), {}, {
    className: cx(rest.className, styles['container']),
    ref: ref,
    children: [/*#__PURE__*/_jsx(HiddenInput, _objectSpread(_objectSpread({}, value && {
      value: value
    }), {}, {
      type: type,
      ref: inputRef,
      checked: checked,
      defaultChecked: defaultChecked,
      disabled: disabled,
      onChange: handleChange,
      tabIndex: tabIndex,
      name: name,
      id: id,
      autoFocus: autoFocus,
      role: role
    })), children]
  }));
});